import { setHeader } from '@/util/set-header'
import React from "react";
import ReactDOM from 'react-dom'
import "./recharge-history.less";
import { withRouter } from 'react-router'
import RechargeHistoryList from "./recharge-history-list/recharge-history-list"
import Cookies from "universal-cookie";
const cookie = new Cookies()
@(withRouter as any)
class RechargeHistory extends React.Component<any, any> {
  mainDiv!: any
  constructor(prop: any) {
    super(prop)
    this.mainDiv = React.createRef()
    this.state = {
      height: (document.documentElement.clientHeight * 3) / 4,
    }
    //绑定this ios低版本不兼容箭头函数
    this.leftClick = this.leftClick.bind(this)
  }
  leftClick() {
    //返回App
    const { history } = this.props
    if (history.length > 1) {
      // history.goBack()
      this.props.history.push({
        pathname: '/sany/dorm-manage',
        state: { id: cookie.get('rechargeListId') }
      })
    } else {
      window.location.href = "uhomeoc://thirdparty.goBack?params={type:native}"
    }
  }
  componentDidMount() {
    setHeader({title: '充值历史', leftClick: this.leftClick })
    const height = document.documentElement.clientHeight - (ReactDOM.findDOMNode(this.mainDiv.current,) as any).getBoundingClientRect().top
    this.setState({ height })
  }
  render() {
   return(
    <div>
      <div style={{height: this.state.height}} ref={this.mainDiv}>
        <RechargeHistoryList></RechargeHistoryList>
      </div>
    </div>
   )
  }
}
export default RechargeHistory